export interface Company {
  id: number;
  name: string;
  minDate?: Date;
  showServiceType?: boolean;
  showCharts?: boolean;
  showStore?: boolean;
}

export const companies: Company[] = [
  {
    id: 1,
    name: "IKEA",
    showServiceType: true,
    showCharts: true,
    showStore:true,
  },
  {
    id: 4,
    name: "PRAXIS",
    minDate: new Date(2025, 0, 1), // January 1st, 2025
    showServiceType: false,
    showCharts: false,
    showStore:false,
  },
  {
    id: 20,
    name: "Leen Bakker",
    minDate: new Date(2026, 0, 1), // January 1st, 2026
    showServiceType: false,
    showCharts: true,
    showStore:true,  
  },
];
